import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "main-search" }
const _hoisted_2 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "select-option-lowlight" }
const _hoisted_5 = { class: "main-search__btn" }
const _hoisted_6 = { class: "mo-button__text" }
const _hoisted_7 = { class: "main-search__result" }
const _hoisted_8 = {
  key: 0,
  class: "main-search__empty"
}
const _hoisted_9 = {
  key: 0,
  class: "main-search__link-wrap"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_d_control_input = _resolveComponent("d-control-input")!
  const _component_vee_form = _resolveComponent("vee-form")!
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _directive_on_click_outside = _resolveDirective("on-click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createVNode(_component_vee_form, {
        class: "main-search__form",
        onSubmit: $setup.submit,
        ref: "formRef"
      }, {
        default: _withCtx(({ errors, meta, validate, values, setFieldError, isSubmitting }) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.FIELDS, ({ name, label, mask, classes, ref, ...rest }) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              ('query' === name)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["main-search__item", classes]),
                    ref_for: true,
                    ref: "inputRef"
                  }, [
                    _createVNode(_component_d_control_input, _mergeProps({
                      name: name,
                      errors: errors,
                      "input-label": label,
                      "static-label": label,
                      modelValue: $setup.form[name],
                      "onUpdate:modelValue": ($event: any) => (($setup.form[name]) = $event),
                      ref_for: true
                    }, rest, _toHandlers(rest.events)), null, 16, ["name", "errors", "input-label", "static-label", "modelValue", "onUpdate:modelValue"])
                  ], 2))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["main-search__item", classes])
                  }, [
                    ('city' === name )
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[3] || (_cache[3] = [
                          _createElementVNode("path", {
                            d: "M8.71357 14H5.00357C4.7939 14.0001 4.58956 14.0661 4.41945 14.1886C4.24933 14.3112 4.12204 14.4841 4.05557 14.683L2.05157 20.683C2.00133 20.8333 1.98754 20.9934 2.01133 21.1501C2.03512 21.3068 2.09581 21.4556 2.1884 21.5842C2.28098 21.7128 2.40282 21.8176 2.54385 21.8899C2.68489 21.9622 2.84109 21.9999 2.99957 22H20.9996C21.1579 21.9999 21.314 21.9621 21.455 21.8899C21.5959 21.8177 21.7176 21.713 21.8102 21.5845C21.9028 21.456 21.9635 21.3074 21.9874 21.1508C22.0113 20.9942 21.9976 20.8343 21.9476 20.684L19.9476 14.684C19.8812 14.4848 19.7539 14.3115 19.5835 14.1888C19.4132 14.066 19.2085 13.9999 18.9986 14H15.2866M17.9996 8C17.9996 11.613 14.1306 15.429 12.6066 16.795C12.4322 16.9282 12.2189 17.0003 11.9996 17.0003C11.7802 17.0003 11.5669 16.9282 11.3926 16.795C9.86957 15.429 5.99957 11.613 5.99957 8C5.99957 6.4087 6.63172 4.88258 7.75693 3.75736C8.88215 2.63214 10.4083 2 11.9996 2C13.5909 2 15.117 2.63214 16.2422 3.75736C17.3674 4.88258 17.9996 6.4087 17.9996 8ZM13.9996 8C13.9996 9.10457 13.1041 10 11.9996 10C10.895 10 9.99957 9.10457 9.99957 8C9.99957 6.89543 10.895 6 11.9996 6C13.1041 6 13.9996 6.89543 13.9996 8Z",
                            stroke: "#6782F6",
                            "stroke-width": "1.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, null, -1)
                        ])))
                      : _createCommentVNode("", true),
                    _createVNode(_component_d_control_input, _mergeProps({
                      name: name,
                      errors: errors,
                      "input-label": label,
                      "static-label": label,
                      modelValue: $setup.form[name],
                      "onUpdate:modelValue": ($event: any) => (($setup.form[name]) = $event),
                      ref_for: true
                    }, rest, _toHandlers(rest.events)), _createSlots({ _: 2 }, [
                      ('city' === name )
                        ? {
                            name: "option",
                            fn: _withCtx(({ option }) => [
                              (option?.id)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                                    _createTextVNode(_toDisplayString(option.title), 1),
                                    _createElementVNode("span", _hoisted_4, " (" + _toDisplayString($setup.formatOption(option)) + ")", 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            key: "0"
                          }
                        : undefined,
                      _renderList(rest.slots, (_slot) => {
                        return {
                          name: _slot.name,
                          fn: _withCtx((r) => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(_slot.component), _mergeProps({ ref_for: true }, {..._slot.props, ...r}), null, 16))
                          ])
                        }
                      })
                    ]), 1040, ["name", "errors", "input-label", "static-label", "modelValue", "onUpdate:modelValue"])
                  ], 2))
            ], 64))
          }), 256)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "mo-button mo-button--variant_primary mo-button--size_md",
              type: "submit",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.submit(true)), ["prevent"]))
            }, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("Search")), 1)
            ])
          ])
        ]),
        _: 1
      }, 512),
      ($setup.result && $setup.result.items && $setup.isShow)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent($setup.isDesktop ? 'div' : $setup.VueFinalModal), {
            key: 0,
            "content-class": "search-result-modal",
            "modal-id": 'search-result-modal',
            modelValue: $setup.isOpen,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.isOpen) = $event))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass($setup.isDesktop ? '' : 'modal')
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass($setup.isDesktop ? '' : 'modal__wrapper')
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    (0 === $setup.result?.items?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t("No result found")), 1))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.result.items, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "main-search__result-item",
                              key: item.id
                            }, [
                              ($setup.SearchCategory.doctor === $setup.form.category?.id)
                                ? (_openBlock(), _createBlock($setup["SearchResultDoctor"], {
                                    key: 0,
                                    item: item
                                  }, null, 8, ["item"]))
                                : _createCommentVNode("", true),
                              ($setup.SearchCategory.medical === $setup.form.category?.id)
                                ? (_openBlock(), _createBlock($setup["SearchResultMedical"], {
                                    key: 1,
                                    item: item
                                  }, null, 8, ["item"]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128)),
                          ($setup.result?.catalogUrl)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("a", {
                                  class: "main-search__link",
                                  href: $setup.result?.catalogUrl
                                }, _toDisplayString($setup.result?.textUrl), 9, _hoisted_10)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                  ]),
                  (!$setup.isDesktop)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "modal-close-button",
                        type: "button",
                        "aria-label": _ctx.$t('Close'),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.isOpen = false))
                      }, [
                        _createVNode(_component_AppIcon, {
                          "aria-hidden": "true",
                          name: "i-close",
                          size: ['lg']
                        })
                      ], 8, _hoisted_11))
                    : _createCommentVNode("", true)
                ], 2)
              ], 2)
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ])), [
      [_directive_on_click_outside, () => { $setup.isShow = false }]
    ]),
    _renderSlot(_ctx.$slots, "default", {
      category: $setup.form.category?.id || $setup.defaultCategory.id
    })
  ], 64))
}